var CrossSellingAddToCart = (function ($) {

    var bindAddToCart = function (sel) {
        if (!$(sel).length){
            return;
        }

        $(document).on("submit", sel, function(event){
            event.preventDefault();
            var $form = $(event.target);
            var token = $("input[name='_csrf']").val();
            var header = "X-CSRF-TOKEN";
            var mainCode = $form.find("input[name='crossSellingProducts[0].id']").val();
            var mainQuantity = $form.find("input[name='crossSellingProducts[0].quantity']").val();
            var crossCode = $form.find("input[name='crossSellingProducts[1].id']").val();
            var crossQuantity = $form.find("input[name='crossSellingProducts[1].quantity']").val();
            var discountedPrice = $form.find(".pdp-combination-total-price").html();

            if (!(mainCode && mainQuantity && crossCode && crossQuantity)) {
                return;
            }

            var products = [];
            products.push({ "code": mainCode, "quantity": mainQuantity });
            products.push({ "code": crossCode, "quantity": crossQuantity });
            var productCartData = {"items": products, "price": '', "discountedPrice": (discountedPrice) ? discountedPrice :'' };

            $.ajax({
                url: "/cart/cross-selling",
                type: "POST",
                data: $form.serialize(),
                beforeSend: function(xhr) {
                    xhr.setRequestHeader(header, token);
                },
                success: function() {
                    $( document ).trigger( "changeCartEvent", productCartData);
                },
                error: function(data) {
                    if (data.status === 400 && data.responseJSON && data.responseJSON.error) {
                        $('#limitCartEntriesMessage').text(data.responseJSON.error);
                        $('#limitCartEntriesModal').modal('show');
                    }
                }
            });
        });
    };

    return {
        bindAddToCart: bindAddToCart
    };
}) (jQuery);

$(document).ready(function() {
    CrossSellingAddToCart.bindAddToCart("#pdp-cross-selling-carousel form.pdp-cross-selling-content-form");
});